import { APICore } from './apiCore';
const api = new APICore();

// user
// eslint-disable-next-line no-empty-pattern


function users(params) {
    const baseUrl = `/users`;
    return api.get(`${baseUrl}`, params);

}
function showUser( params, id) {
    const baseUrl = `/users/${id}`;
    return api.get(`${baseUrl}`, params);

}





export { users, showUser };
